import di from "di";
import { sample } from 'lodash'

import AllPromotions from 'common/gql/query/store/promotions/AllPromotions.gql'
import PromotionState from '../enum/PromotionState';

export const PromotionStoreAction = {
    POPULATE_PROMOTIONS: 'POPULATE_PROMOTIONS',
    LOAD_PROMOTIONS: 'LOAD_PROMOTIONS',
    EXECUTE_PROMOTIONS_OPERATION: 'EXECUTE_PROMOTIONS_OPERATION'
}

export const PromotionStoreMutation = {
    SET_PROMOTIONS: 'SET_PROMOTIONS',
    UPDATE_RANDOM_PROMOTION: 'UPDATE_RANDOM_PROMOTION'
}

function createEmptyState() {

    return {
        promotions: null,
        randomPromotion: null
    };
}

export const promotionsStore = {

    state(){

        return createEmptyState();
    },

    getters: {

        getPromotion: state => id => {
            return state.promotions?.find(promotion => promotion.id == id);
        }
    },

    mutations: {

        clear(state) {
            Object.assign(state, createEmptyState());
        },

        [PromotionStoreMutation.SET_PROMOTIONS] (state, promotions){

            state.promotions = promotions
        },

        [PromotionStoreMutation.UPDATE_RANDOM_PROMOTION] (state){

            const availablePromotions = state.promotions.filter(promo => promo.state === PromotionState.AVAILABLE);
            state.randomPromotion = sample(availablePromotions);
        }
    },

    actions: {

        async [PromotionStoreAction.POPULATE_PROMOTIONS] (ctx){

            return ctx.dispatch(PromotionStoreAction.LOAD_PROMOTIONS)
        },

        async [PromotionStoreAction.LOAD_PROMOTIONS] (ctx, options){

            const apollo = di.get('apollo');

            const results = await apollo.query({
                query: AllPromotions,
                fetchPolicy: options?.force ? 'network-only' : null
            });

            const promotions = results.data?.allPromotions?.items;
            ctx.commit(PromotionStoreMutation.SET_PROMOTIONS, promotions);

            ctx.commit(PromotionStoreMutation.UPDATE_RANDOM_PROMOTION);
        },

        async [PromotionStoreAction.EXECUTE_PROMOTIONS_OPERATION] (ctx){

            return ctx.dispatch(PromotionStoreAction.LOAD_PROMOTIONS, { force: true });
        }
    }
}